import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';

import PrivateChatModal from '../Components/Chat/PrivateChatModal';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'PrivateChat'>;

const PrivateChatScreen: React.FC<Props> = ({ navigation, route }) => {
	const { playerId, username } = route.params;

	return (
		// Keyed by the player: opening another chat on top of this one starts it afresh.
		<PrivateChatModal
			key={playerId}
			playerId={playerId}
			username={username}
			onClose={() => {
				if (navigation.canGoBack()) {
					navigation.goBack();
				} else {
					navigation.navigate('Main');
				}
			}}
		/>
	);
};

export default PrivateChatScreen;
